export enum TransactionType {
  HOLD = "Hold",
  RESUME = "Resume",
  EXTEND = "Extension",
  DROP = "Drop",
  MATERIALS = "Materials",
  ADJUST = "Adjust",
}
